import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const CustomDatasetActionDropdownTrigger = ({ openDropdown, disabled }) => (
  <RibbonMenu
    name="custom-actions.more"
    icon="ellipsis horizontal"
    message="actions.custom-actions.more"
    onClick={openDropdown}
    className="aridhia-custom-dataset-action-dropdown-trigger"
    disabled={disabled}
  />
);

export default CustomDatasetActionDropdownTrigger;
